import { Box, Button, Card, Dialog, DialogContent, DialogTitle, Grid, IconButton, Menu, MenuItem, TextField, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useLocation, useNavigate, } from "react-router-dom";
import { MdOutlineWatchLater } from "react-icons/md";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DataTable from "react-data-table-component";
import CustomTable from "../../../components/customTable/customTable";
import { useEffect, useState } from "react";
import { update } from "../../../slice/jobSlice";

import { setControlUser, setPortalControlBy } from "../../../slice/userSlice";
import { API_URL } from "../../../appConstants";
import { useTMutation } from "../../../utils/useTMutation";
import showToast from "../../../components/Hot-Toast/showToast";
import IMAGE from "../../../assets/images/big/abcz.png";

const ViewJobAndClinician = () => {
    let view = false;
    const dispatch = useDispatch();
    const location = useLocation();
    // Use URLSearchParams to parse the query string and extract 'checkStatus'



    const navigate = useNavigate();
    const [event, setEvent] = useState({})
    const { jobData } = useSelector(state => state.job);
    const { userDetails } = useSelector(state => state.user);
    const [anchorEl, setAnchorEl] = useState(null);
    const [rows, setRows] = useState([]);
    const [schedule, setSchedule] = useState({});
    const [openPopup, handlePopupClose] = useState(false);
    const [data, setData] = useState("")
    const { mutateAsync } = useTMutation(openPopup ? "/job/addJobTimesheet" : "/job/addUpdateJob", "post", (data => { return data }))

    const mutation = useTMutation("/job/fetchJobTimeSheet", "post", (data) => {
        if (data.STATUS) {
            setData(data)
            setRows(data?.OUTPUT[0]?.WORK_TIME);
            setTime(data?.OUTPUT[0]?.TOTAL_TIME);
            return data;
        } else {
            showToast("error", data.MESSAGE, 3000);
        }
    });
    const [timeValiue, setTime] = useState("")
    const [value, setValue] = useState({
    })



    const viewTimeSheet = (row) => {
        const jobDate = row?.jobDetails?.SERVICE_DATE;
        localStorage.setItem("jobDate", jobDate);
        navigate(`/facility/ClinicianTimesheet/${row?.clinicianId}/${row?.jobID}`)
    }

    const approveTimeSheet = () => {
        mutateAsync({
            ...value,
            STATUS: "Approved", // Toggle based on current state
        });
    }

    let columns = [

        {
            name: 'Time_Entry Name',
            selector: row => row?.Time_Entry,
            reorder: true,
            sortable: true,
        },

        {
            name: 'CLOCK_IN',
            selector: row => row?.CLOCK_IN,
            reorder: true,
            sortable: true,
        },
        {
            name: 'CLOCK_OUT',
            selector: row => row.CLOCK_OUT,
            reorder: true,
            sortable: true,
        },


    ]



    const handleApplicantStatus = (row) => {
        const clinicianID = row?.clinician?.ID;
        const clinicianInFacilityID = row?.ID;
        const clinicianStatus = row?.clinicianStatus;
        dispatch(setPortalControlBy('facility'));
        dispatch(setControlUser(clinicianID));
        navigate(`/facility/clinican-users/${clinicianID}/${clinicianInFacilityID}/${clinicianStatus}`);
    }

    let col = [
        {
            name: 'CLINICIAN',
            selector: row => row?.clinician?.FULL_NAME,
            reorder: true,
            sortable: true,

        },
        {
            name: 'ROLE',
            selector: row => row.clinician?.jobRole?.ROLE_NAME,
            reorder: true,
            sortable: true,

        },
        {
            name: 'JOB STATUS',
            selector: row => row.clinicianStatus,
            reorder: true,
            sortable: true,

        },
        {
            name: 'ACTIONS',
            button: true,
            cell: row => (
                <div style={{ paddingLeft: "15px" }}>

                    <Tooltip title="View Applications">
                        <IconButton size="small" onClick={() => {
                            viewTimeSheet(row);
                        }}>
                            <MoreHorizIcon />
                        </IconButton>
                    </Tooltip>



                </div>
            ),
            reorder: true,
            center: true
        }

    ]
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = async (val) => {
        if (typeof val == "string") {
            try {
                const response = await mutateAsync({ ID: jobData?.ID, JOB_STATUS: val });
                if (response.STATUS) {

                    dispatch(update({ JOB_STATUS: val }))
                    showToast("success", `Application Status Changed to ${val} `, 3000);
                    setAnchorEl(null);
                } else {
                    setAnchorEl(null);
                    showToast("error", response.MESSAGE, 3000);
                }
            } catch (error) {
                console.error("Validation Request failed:", error.message);
                showToast("error", "Something went wrong, Please try again", 3000);
            }
        } else {
            setAnchorEl(null);
        }



    };
    // PROFILE_IMAGE_PATH
    // setProfileImageUrl(API_URL + "user/viewFile?fileName=" + data?.about?.PROFILE_IMAGE_PATH);

    const settingJobSchedule = (schedule) => {
        setSchedule(schedule)
    }

    return (
        <>
            <Grid container >

                <Box onClick={() => navigate(-1)} sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginLeft: -0.8 }}>
                    <IconButton >
                        <ChevronLeftIcon />
                    </IconButton>
                    <Typography variant="body1"  >
                        Back
                    </Typography>
                </Box>

                <Grid item lg={12}>
                    <Card>
                        <Grid container lg={12}>

                            <Grid item lg={6} px={2} mt={-0.8}>
                                {/* <Box>
                                    <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                    <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>

                                    {jobData?.SERVICE_TYPE === "Recurring" ?
                                        <>
                                            {jobData?.SERVICE_DURATION?.map((jobdata) =>
                                                <Box display="flex" gap={1}>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobdata?.JOB_DAY}</Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobdata?.JOB_IN_TIME}</Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobdata?.JOB_OUT_TIME}</Typography>
                                                </Box>
                                            )}
                                        </> : <>

                                            <Box display="flex" gap={1}>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.job_services[0]?.JOB_IN_TIME}</Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.job_services[0]?.JOB_OUT_TIME}</Typography>
                                            </Box>
                                        </>
                                    }

                                    <Typography variant="h4" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>Glendora, CA</Typography>
                                </Box> */}
                                <Box>
                                    <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>
                                    <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>

                                    {jobData?.SERVICE_TYPE === "Recurring" ?
                                        <>
                                            {schedule?.SERVICE_DURATION?.map((jobdata) =>
                                                <Box display="flex" gap={1}>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobdata?.JOB_DAY}</Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobdata?.JOB_IN_TIME}</Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobdata?.JOB_OUT_TIME}</Typography>
                                                </Box>
                                            )}
                                        </> : <>

                                            <Box display="flex" gap={1}>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.job_services[0]?.JOB_IN_TIME}</Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.job_services[0]?.JOB_OUT_TIME}</Typography>
                                            </Box>
                                        </>
                                    }

                                    <Typography variant="h4" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>Glendora, CA</Typography>
                                </Box>
                                <Box display="flex" style={{ flexWrap: 'wrap' }} gap={3} mt={2} justifyContent="start">
                                    {jobData?.jobs_role?.ROLE_NAME && <Typography style={{ backgroundColor: "#eef7e9", borderRadius: "20px", padding: "10px 20px", color: 'linear-gradient(to right,#4eb3e8,#6ebe44)', fontWeight: 500, fontSize: "14px" }}>{jobData?.jobs_role?.ROLE_NAME}</Typography>}
                                    {jobData?.JOB_TYPE && <Typography style={{ backgroundColor: "#eef7e9", borderRadius: "20px", padding: "10px 20px", color: 'linear-gradient(to right,#4eb3e8,#6ebe44)', fontWeight: 500, fontSize: "14px" }}>{jobData?.JOB_TYPE}</Typography>}
                                    {jobData?.SERVICE_TYPE && <Typography style={{ backgroundColor: "#eef7e9", borderRadius: "20px", padding: "10px 20px", color: 'linear-gradient(to right,#4eb3e8,#6ebe44)', fontWeight: 500, fontSize: "14px" }}>{jobData?.SERVICE_TYPE}</Typography>}
                                </Box>
                            </Grid>
                            <Grid lg={6} item>
                                {jobData?.checkStatus !== "offerAccept" &&
                                    <Box display="flex" mt={2} justifyContent="end" p={2}>
                                        <Grid mt={1}>
                                            <Typography style={{ backgroundColor: jobData?.JOB_STATUS === "Clinician Hired" ? 'linear-gradient(to right,#4eb3e8,#6ebe44)' : "#f6b613", borderRadius: "20px", padding: "1px 20px", color: "#ffffff", fontWeight: 500, fontSize: "14px" }}>{jobData?.JOB_STATUS}</Typography>
                                        </Grid>
                                        <IconButton p={0} onClick={handleClick}>
                                            <MoreHorizIcon />
                                        </IconButton>

                                    </Box>}
                                <Menu
                                    id="notification-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                    sx={{
                                        "& .MuiMenu-paper": {
                                            width: "200px",
                                            right: 0,
                                            top: "70px !important",
                                        },
                                    }}
                                >
                                    <MenuItem onClick={() => handleClose("Open for Applications")}>Open for Applications</MenuItem>
                                    <MenuItem onClick={() => handleClose("Clinician Hired")}>Clinician Hired</MenuItem>
                                </Menu>
                            </Grid>

                        </Grid>
                    </Card>
                </Grid>
            </Grid>

            <Grid mt={2}>
                <CustomTable
                    column={col}
                    event={(e) => { setEvent(e) }}
                    url={"/job/fetchInterstedClinician"}
                    headline={"Applicant"}
                    payload={{ JOB_ID: jobData?.ID, SPECIALTY_ID: jobData?.SPECIALTY_ID, CHECKSTATUS: "OfferAccepted" }}
                    jobSchedule={settingJobSchedule}
                />

            </Grid>


            <Grid container spacing={1} justifyContent="space-around" mt={2} px={3} pb={18}>
                <Grid item lg={4} pb={2}>
                    <Card  >
                        <Grid container alignItems="center" spacing={1} justifyContent="space-around" px={3} pb={3}>
                            <Grid item xs={12} sm={12} display="flex" gap={3}>
                                <Typography pt={2}>
                                    <img
                                        src={jobData?.user?.PROFILE_IMAGE_PATH
                                            ? API_URL + "user/viewFile?fileName=" + jobData?.user?.PROFILE_IMAGE_PATH
                                            : IMAGE}
                                        alt="profile"
                                        style={{ width: '100px' }}
                                    />

                                </Typography>
                                <Typography>
                                    <Box pt={2}>
                                        <Typography style={{ fontWeight: 500, fontSize: "14px", color: "#000000", opacity: "87%" }}>{jobData?.user?.FACILITY_NAME}</Typography>
                                        <Typography style={{ fontWeight: 400, fontSize: "12px", color: "#000000", opacity: "60%" }}>{jobData?.user?.STREET_ADDRESS}</Typography>
                                    </Box>
                                </Typography>
                            </Grid>
                           <Grid item xs={12} sm={12}>
                                    <Box>
                                        <Typography variant="h2" pt={2} style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>{jobData.jobs_role.ROLE_NAME}</Typography>
                                        <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                                        <Box display="flex" gap={1} pt={2}>
                                            {jobData?.SERVICE_TYPE === "Recurring" ? <>
                                                <Box
                                                    display="grid"
                                                    gridTemplateColumns="repeat(auto-fit, minmax(160px, 1fr))"
                                                    gap={2}
                                                    width="100%"
                                                >
                                                    {jobData?.SERVICE_DURATION?.map((job, index) => (
                                                        <Box
                                                            key={index}
                                                            display="flex"
                                                            alignItems="center"
                                                            width="100%"
                                                            minWidth="160px"
                                                        >
                                                            <Typography
                                                                variant="h2"
                                                                pt={1}
                                                                style={{ fontWeight: 400, fontSize: "12px", color: "#000000", opacity: "60%" }}
                                                            >
                                                                <MdOutlineWatchLater />
                                                            </Typography>
                                                            <Typography
                                                                pt={1}
                                                                px={1}
                                                                variant="h2"
                                                                style={{ fontWeight: 400, fontSize: "12px", color: "#000000", opacity: "60%" }}
                                                            >
                                                                {`${job?.JOB_DAY?.slice(0, 3)} ${job?.JOB_IN_TIME}-${job?.JOB_OUT_TIME}`}
                                                            </Typography>
                                                        </Box>
                                                    ))}
                                                </Box>

                                            </> : <>
                                                <Box display="flex" gap={1}>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{new Date(jobData?.job_services[0]?.JOB_IN_TIME).toLocaleTimeString()}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                                                    <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{new Date(jobData?.job_services[0]?.JOB_OUT_TIME).toLocaleTimeString()}</Typography>
                                                </Box>
                                            </>}
                                        </Box>
                                       {jobData?.facility_addlocation?.STREET_ADDRESS && <Typography variant="h4" pt={2} style={{ fontWeight: 500, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.facility_addlocation?.STREET_ADDRESS}</Typography>}
                                    </Box>
                                </Grid>
                        </Grid>

                        <hr style={{ marginTop: "20px", color: "#000000", opacity: "60%", width: "90%", margin: "0 auto" }} />

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    {/* <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Title</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData.JOB_ROLE_NAME}</Typography> */}
                                </Box>
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Speciality</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.specialty?.SPECIALTY_NAME}</Typography>
                                </Box>
                            </Typography>

                        </Box>
                        {jobData?.STAFFING_SOLUTION && <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Staffing Solution</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.STAFFING_SOLUTION}</Typography>
                                </Box>
                            </Typography>

                        </Box>}


                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Job Type</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.JOB_TYPE}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Hiring Type</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.HIRING_TYPE}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Shift Type</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.SERVICE_TYPE}</Typography>
                                </Box>
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Start Date</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{new Date(jobData?.SERVICE_DATE).toDateString()}</Typography>
                                </Box>
                            </Typography>

                        </Box>
                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                                                        <Typography>
                                                            <Box>
                                                                <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>End Date</Typography>
                                                                <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.SERVICE_END_DATE ? new Date(jobData.SERVICE_END_DATE).toDateString() : 'N/A'}</Typography>
                                                            </Box>
                                                        </Typography>
                        
                                                    </Box>

                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Working Days</Typography>

                                </Box>

{jobData?.SERVICE_DURATION
                                        ? jobData?.SERVICE_DURATION?.map((data) =>
                                            <Box display="flex" gap={1}>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}><MdOutlineWatchLater /></Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data?.JOB_DAY}</Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_IN_TIME}</Typography>  <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>-</Typography>
                                                <Typography variant="h2" pt={2} style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{data.JOB_OUT_TIME}</Typography>
                                            </Box>
                                        )

                                        :
                                        // jobData?.JOB_SERVICE_WITH_DAY_TIME &&
                                        // (<Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>
                                        //     {jobData.JOB_SERVICE_WITH_DAY_TIME[0]?.JOB_DAY}-{jobData.JOB_SERVICE_WITH_DAY_TIME[jobData.JOB_SERVICE_WITH_DAY_TIME.length - 1]?.JOB_DAY}
                                        // </Typography>)
                                         jobData?.SERVICE_DATE && jobData?.SERVICE_END_DATE && (
    <Typography
      variant="h6"
      style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}
    >
      {new Date(jobData.SERVICE_DATE).toLocaleDateString("en-US", { weekday: "short" })}
      {" - "}
      {new Date(jobData.SERVICE_END_DATE).toLocaleDateString("en-US", { weekday: "short" })}
    </Typography>
  )
                                    }
                            </Typography>
                        </Box>

                        {jobData.SERVICE_TYPE !== "Recurring" && (
                                                       <Box display="flex" justifyContent="space-between" px={2} pt={1.2} >
                                                           <Typography>
                                                               <Box>
                                                                   <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }} >Time</Typography>
                                                                   <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>{jobData?.JOB_IN_TIME} - {jobData?.JOB_OUT_TIME}</Typography>
                                                               </Box>
                                                           </Typography>
                                                       </Box>
                                                   )}


                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Location</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }} >{userDetails?.STREET_ADDRESS}</Typography>
                                </Box>
                            </Typography>

                        </Box>


                        <Box display="flex" justifyContent="space-between" px={2} pt={1.2}>
                            <Typography>
                                <Box>
                                    <Typography variant="h4" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>Pay</Typography>
                                    <Typography variant="h6" style={{ fontWeight: 400, fontSize: "14px", color: "#000000", opacity: "60%" }}>${jobData.PAY_AMOUNT_FROM}-{jobData.PAY_AMOUNT_TO}/hr</Typography>
                                </Box>
                            </Typography>

                        </Box>


                    </Card>


                </Grid>
                <Grid item lg={8} mt={0}>
                    <Card >
                        <Grid container alignItems="center" spacing={1} justifyContent="space-around" p={3} pb={3}>
                            <Grid item xs={12} sm={12} display="flex" justifyContent="space-between">

                                <Typography variant="h3" style={{ fontWeight: 600, fontSize: "20px", color: "#000000", opacity: "87%" }}>
                                    Job Description
                                </Typography>

                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography id="delete-modal-title" variant="h6" component="h2" style={{ fontWeight: 400, fontSize: "16px", color: "#000000", opacity: "60%" }}>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: jobData.JOB_DESCRIPION }}
                                    />
                                </Typography >

                                {/* <Typography mt={2} id="delete-modal-title"  variant="h6" component="h2" style={{fontWeight:400 ,fontSize:"16px",color:"#000000",opacity:"60%"}}>
                           If you are interested in per diem hospital opportunities, have the experience listed below, and live in the Kansas City KS metro area, then fill out this form and our team will reach out to you with further instructions if you meet the facility’s necessary criteria. 
                           </Typography> */}
                            </Grid>
                            <Grid item xs={12} sm={12} mt={3} >

                                <Box display="flex" justifyContent="space-between">
                                    <Typography variant="h3" style={{ fontWeight: 500, fontSize: "16px", color: "#000000", opacity: "87%" }}>
                                        Responsibilities:
                                    </Typography>

                                </Box>


                                <Typography px={2.5} pt={1}>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: jobData.JOB_RESPONSIBILITY }}
                                    />
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                {/* <Typography id="delete-modal-title"  variant="h5" component="h2">
                           {jobData?.JOB_RESPONSIBILITY}
                    </Typography> */}
                            </Grid>
                        </Grid>


                    </Card>




                </Grid>


            </Grid>


            {openPopup &&
                <Dialog open={openPopup}
                    onClose={() => { handlePopupClose(false); view = false; }}
                    maxWidth="md" fullWidth
                >
                    <Box style={{ display: "flex", justifyContent: "space-between", backgroundColor: 'linear-gradient(to right,#4eb3e8,#6ebe44)', color: "#ffffff" }}>
                        <DialogTitle mt={0.5} style={{ fontSize: "14px" }}>Create Shift</DialogTitle>
                        <DialogTitle >
                            {/* <CloseIcon onClick={handlePopupClose} style={{ color: "#ffffff", marginTop: 1, cursor: "pointer" }} /> */}
                        </DialogTitle>
                    </Box>

                    <DialogContent>
                        <form
                        // onSubmit={handleSubmit(onSubmitAddShift)}
                        >
                            <Grid container spacing={2}  >


                                <Grid item lg={12}>

                                    <DataTable
                                        className="table-items"
                                        columns={columns}
                                        data={rows}
                                    // customStyles={customStyles}
                                    // onSort={handleSort}
                                    // sortServer
                                    /></Grid>
                                <Grid container display={"flex"} justifyContent={"end"}>

                                    <Grid item lg={2} mt={1}>
                                        <TextField
                                            label="Total Time"
                                            variant="outlined"
                                            fullWidth
                                            disabled
                                            value={timeValiue}
                                            autoFocus
                                            // onChange={(e)=> setTimeEntryName(e.target.value)}
                                            // value={watch('facilityName') || FACILITY_NAME}
                                            sx={{
                                                '& .MuiOutlinedInput-input': { padding: 1.814 },
                                                '& .MuiFormHelperText-root': { marginLeft: 0, marginTop: '4px' },
                                            }}
                                        />

                                    </Grid>
                                </Grid>
                                <Grid container justifyContent={'center'}>

                                    {data != "" && data?.OUTPUT[0]?.STATUS == "Approved" &&
                                        <DialogTitle mt={0.5} style={{ fontSize: "14px" }}>Time Sheet : <span style={{ fontWeight: 700, color: "#71ba32" }}> Approved</span></DialogTitle>

                                    }
                                </Grid>

                                <Grid container mt={1} justifyContent={"center"} gap={2}>
                                    <Button variant="outlined" color="secondary" onClick={() => { handlePopupClose(false); view = false }}>
                                        Cancel
                                    </Button>
                                    {data != "" && data?.OUTPUT.length > 0 && data?.OUTPUT[0]?.STATUS != "Approved" &&
                                        <Button variant="contained" color="error" onClick={() => approveTimeSheet()}>
                                            Accept Time Sheet
                                        </Button>}

                                </Grid>


                            </Grid>
                        </form>

                    </DialogContent>

                </Dialog>
            }


        </>


    )
};

export default ViewJobAndClinician;

